import { useUpdate } from "../../contexts/UpdateContext";
import {
  StyledHeaderContainer,
  StyledHeaderContainerText,
  StyledHeroHeadingThinContainer,
} from "../styles/containers/Containers";
import { StyledHeroHeadingThin } from "../styles/Typography/Typography";

const HeaderSection = () => {
  const { currentViewHeading } = useUpdate();
  return (
    <>
      <StyledHeaderContainer>
        <StyledHeaderContainerText>
          <StyledHeroHeadingThinContainer>
            {currentViewHeading}
          </StyledHeroHeadingThinContainer>
          {/* <StyledHeroHeadingThin>{currentViewHeading}</StyledHeroHeadingThin> */}
        </StyledHeaderContainerText>
      </StyledHeaderContainer>
      {/* <StyledHeaderContainer>
        <StyledHeroHeadingThin>{currentViewHeading}</StyledHeroHeadingThin>
      </StyledHeaderContainer> */}
    </>
  );
};

export default HeaderSection;
